import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router';

import { DynamicFeatureFlag, useFeatureFlag } from '@sbu/hooks.featureflag';

export const cseLicenseUnavailablePath =
  '/unavailable?type=license&feature=cse';

export const LicenseRouteGuard = ({
  component: Component,
  render,
  ...rest
}: RouteProps) => {
  const hasCSELicense = useFeatureFlag(DynamicFeatureFlag.CSEEnabled);

  if (!hasCSELicense) {
    return null;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!hasCSELicense) {
          return <Redirect to={cseLicenseUnavailablePath} />;
        } else if (Component) {
          return <Component {...props} />;
        } else if (render) {
          return render(props);
        }
        return null;
      }}
    />
  );
};
